import React from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import ChargingStationTable from "components/ChargingStationTable/ChargingStationTable";
import { chargingStationApi } from "stores/ChargingStationStore/chargingStationApi";
import ConfirmDeleteStationModel from "components/ChargingStationTable/ConfirmDeleteStationModel";
import ConfirmDeleteConnectorModel from "components/ChargingStationTable/ConfirmDeleteConnectorModel";
import Box from "components/common/Box";
import ChargingTableEnableDisable from "components/ChargingStationTable/ChargingTableEnableDisable";
import TitleBox from "../../components/common/TitleBox";
import Stack from "components/common/Stack";
import Grid from "@mui/material/Grid";
import Text from "components/common/Text";
import Link from "components/common/Link";
import { Button } from "@mui/material";
import Paper from "@mui/material/Paper";

class ChargingStationTableContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: "",
        station_id: "",
        cp_id: "",
        connectors: [
          {
            charger_type_id: "",
            price_per_khw: "",
            power: "",
          },
        ],
      },
      connectorAdd: {
        charge_point_id: "",
        charger_type_id: "",
        power: "",
        price_per_khw: "",
      },
      chargingPointEdit: {
        id: "",
        name: "",
        station_id: "",
        cp_id: "",
      },
      ////
      chargingConnectorEdit: {
        id: "",
        name: "",
        charge_point_id: "",
        charger_type_id: "",
        power: "",
        price_per_khw: "",
      },

      formError: {
        name: false,
        station_id: false,
        cp_id: false,
        connectors: [],
      },
      setOpen: false,
      deleteSuccess: false,
      viewDrawer: false,
      addDrawer: false,
      addConnectorDrawer: false,
      EditConnectorDrawer: false,
      EditChargingPointDrawer: false,
      charging_point_Success: false,
      charging_point_Edit_Success: false,
      deleteConfirmStationDaialog: false,
      deleteConfirmConnectorDaialog: false,
      charging_Connector_Success: false,
      charging_Connector_Edit_Success: false,
      deleteconfirm: false,
      EditConnectorID: "",
      EditCh_PointIndex: "",
      deleteStationId: "",
      deleteConnectorId: "",
      EditCh_ConnectorIndex: "",
      openEnableDisableChargingTable: false,
      ChargingTableStatus: "",
      ChargingTableStatusID: "",
      selectedVendor: "",
    };
  }

  handleChangeChPointAdd = (name, value) => {
    const { formData } = this.state;
    formData[name] = value;
    this.setState({ formData });
  };

  hendleChangeConnectorAdd = (name, value) => {
    const { connectorAdd } = this.state;

    connectorAdd[name] = value;
    this.setState({ connectorAdd });
  };

  handleChangeConnector = (index, event) => {
    let data = [...this.state.formData.connectors];
    data[index][event.target.name] = event.target.value;
    this.setState({ formData: { ...this.state.formData, connectors: data } });
  };

  addFieldsConnector = () => {
    let newFields = { charger_type_id: "", power: "", price_per_khw: "" };
    let data = [...this.state.formData.connectors];
    data.push(newFields);
    this.setState({ formData: { ...this.state.formData, connectors: data } });
  };

  removeFieldsConnector = (index) => {
    let data = [...this.state.formData.connectors];
    data.splice(index, 1);
    this.setState({ formData: { ...this.state.formData, connectors: data } });
  };

  handleClickOpen = () => {
    this.setState({ setOpen: true });
  };

  handleClose = (value) => {
    this.setState({ setOpen: false });
  };

  ///////// ch point
  handleSubmitAddChPoint = async () => {
    const { formData } = this.state;
    try {
      const res = await chargingStationApi.Add_ChargingPointApi({
        name: formData.name,
        station_id: formData.station_id,
        cp_id: formData.cp_id,
        connectors: formData.connectors,
      });

      if (res.status === 1) {
        this.setState({ charging_point_Success: true });
        this.setState({
          setOpen: true,
          addDrawer: false,
          charging_point_Success: true,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  ///ch connector
  handleSubmitConnector = async () => {
    const { connectorAdd } = this.state;

    try {
      const res = await chargingStationApi.Add_ChargingConnectorApi({
        charger_type_id: connectorAdd.charger_type_id,
        power: connectorAdd.power,
        price_per_khw: connectorAdd.price_per_khw,
        charge_point_id: connectorAdd.charge_point_id,
      });

      if (res.status === 1) {
        this.setState({
          setOpen: true,
          addConnectorDrawer: false,
          charging_Connector_Success: true,
          viewDrawer: false,
        });
      }
    } catch (error) {
      console.log(error);
      alert(" Error to add Charging Connector");
    }
  };

  async componentDidMount() {
    if (this.props.history?.location?.VendorDetailId) {
      await this.props.getChargingStationsAction({
        VendorDetailId: this.props.history?.location?.VendorDetailId,
        city: this.props.history?.location?.selectedCity,
      });
    } else {
      await this.props.getChargingStationsAction();
    }

    await this.props.getAmenitiesAction();
    await this.props.getChargingPointAction();
    await this.props.chargerTypeAction();
    await this.props.getVendorSelectWiseAction();
    await this.props.getChargingStationCountAction();
  }

  componentDidUpdate() {
    if (this.state.deleteSuccess === true) {
      setTimeout(() => {
        this.props.getChargingStationsAction(this.props.profile.vendor_id);
        this.setState({ deleteSuccess: false });
      }, 100);
    }
  }

  handleDeleteConfirmStationClick = async (id) => {
    this.setState({ deleteConfirmStationDaialog: true, deleteStationId: id });
  };

  handleDeleteStationClick = async () => {
    let id = this.state.deleteStationId;

    if (id !== undefined) {
      await this.props.deleteChargingStationAction({ id });
      this.setState({
        deleteConfirmStationDaialog: false,
        deleteStationId: "",
      });
      this.setState({ deleteSuccess: true });
      await this.props.getChargingStationsAction(this.props.profile.vendor_id);
      this.setState({ deleteSuccess: false });
    }
  };

  handleDeleteConfirmConnectorClick = (id) => {
    this.setState({
      deleteConfirmConnectorDaialog: true,
      deleteConnectorId: id,
    });
  };

  handleDeleteConnectorClick = () => {
    let id = this.state.deleteConnectorId;

    if (id !== undefined) {
      this.props.deleteChargingConnectorAction({ id });
      this.setState({
        deleteConfirmConnectorDaialog: false,
        deleteConnectorId: "",
      });
      this.setState({ deleteSuccess: true });
      this.setState({ viewDrawer: false });
    }
  };

  handleAddChPoint = (id) => {
    this.setState({ addDrawer: true });
    if (id !== undefined) {
      const { formData } = this.state;
      formData.station_id = id;
      this.setState({ formData });
    }
  };
  handleAddChPointClose = () => {
    this.setState({ addDrawer: false });
  };

  handleShowChPoint = (id) => {
    this.props.getChargingPointAction(id);
    this.setState({ viewDrawer: true });
    const { formData } = this.state;
    formData.station_id = id;
    this.setState({ formData });
  };

  handleShowChPointClose = () => {
    this.setState({ viewDrawer: false });
  };

  handleOpenAddConnectorDr = (id) => {
    this.setState({ addConnectorDrawer: true });
    const { connectorAdd } = this.state;
    connectorAdd.charge_point_id = id;
    this.setState({ connectorAdd });
  };

  //Edit Ch Point
  handleOpenEditChPoint = (id, index) => {
    this.setState({ EditChargingPointDrawer: true });
    const { chargingPointEdit } = this.state;
    chargingPointEdit.id = id;

    this.setState({ chargingPointEdit, EditCh_PointIndex: index });
  };

  handleSubmitEditChPoint = async () => {
    const { chargingPointEdit } = this.state;

    try {
      const res = await chargingStationApi.Edit_ChargingPointApi({
        name: chargingPointEdit.name,
        station_id: chargingPointEdit.station_id,
        cp_id: chargingPointEdit.cp_id,
        id: chargingPointEdit.id,
      });

      if (res.status === 1) {
        this.setState({
          charging_point_Edit_Success: true,
          EditChargingPointDrawer: false,
          viewDrawer: false,
        });
        this.setState({
          setOpen: true,
          addDrawer: false,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  handleChangeChPointEdit = ({ name, value }) => {
    const { chargingPointEdit } = this.state;
    chargingPointEdit[name] = value;
    this.setState({ chargingPointEdit });
  };

  handleCloseAddConnectorDr = () => {
    this.setState({ addConnectorDrawer: false });
  };

  //Edit connector

  handleOnclickEditConnectorOpen = (
    charge_point_id,
    connecter_id,
    index,
    name,
    capacity,
    rate
  ) => {
    this.setState({ EditConnectorDrawer: true });
    const { chargingConnectorEdit } = this.state;
    chargingConnectorEdit.id = connecter_id;
    chargingConnectorEdit.charge_point_id = charge_point_id;
    chargingConnectorEdit.power = capacity;
    chargingConnectorEdit.name = name;
    chargingConnectorEdit.price_per_khw = rate;
    this.setState({ chargingConnectorEdit, EditCh_ConnectorIndex: index });
  };

  handleSubmitEditConnector = async () => {
    const { chargingConnectorEdit } = this.state;

    try {
      const res = await chargingStationApi.Edit_ChargingConnecApi({
        charger_type_id: chargingConnectorEdit.charger_type_id,
        charge_point_id: chargingConnectorEdit.charge_point_id,
        price_per_khw: chargingConnectorEdit.price_per_khw,
        power: chargingConnectorEdit.power,
        id: chargingConnectorEdit.id,
      });

      if (res.status === 1) {
        this.setState({
          charging_Connector_Edit_Success: true,
          EditConnectorDrawer: false,
          viewDrawer: false,
        });
        this.setState({
          setOpen: true,
          addDrawer: false,
        });
      }
    } catch (error) {
      console.log(error);
      alert("Error data not updated");
    }
  };

  handleChangeConnectorEdit = (name, value) => {
    const { chargingConnectorEdit } = this.state;
    chargingConnectorEdit[name] = value;
    this.setState({ chargingConnectorEdit });
  };

  handleCloseEditConnector = () => {
    this.setState({ EditConnectorDrawer: false });
  };

  //Edit Ch Point
  handleCloseEditChPoint = () => {
    this.setState({ EditChargingPointDrawer: false });
  };

  handleCloseDeleteStationConfirm = () => {
    this.setState({ deleteConfirmStationDaialog: false });
  };

  handleCloseDeleteConnectorConfirm = () => {
    this.setState({ deleteConfirmConnectorDaialog: false });
  };

  handleOnchangeSelectCity(values) {
    if (values === "all2") {
      this.props.getChargingStationsAction();
      this.setState({
        selectedVendor: "",
      });
    }
    else {
      this.props.getChargingStationsAction({ VendorDetailId: values });
      this.setState({
        selectedVendor: values,
      });
    }
  }
  handleChargingTableEnableDisableModelOpen = (id, status) => {
    this.setState({
      openEnableDisableChargingTable: true,
      ChargingTableStatus: status,
      ChargingTableStatusID: id,
    });
  };
  handleChargingTableEnableDisableModelClose = () => {
    this.setState({ openEnableDisableChargingTable: false });
  };

  handleEnableClickChargingTable = async () => {
    const status = this.state.ChargingTableStatus;
    const id = this.state.ChargingTableStatusID;
    const { selectedVendor } = this.state;
    let body = {
      VendorDetailId: selectedVendor,
    };

    if (status === 1) {
      await chargingStationApi.AddChargingTableEnableDisableApi({
        id,
        status: 0,
      });
      this.setState({ ChargingTableStatus: 0 });
      this.props.getChargingStationsAction(selectedVendor ? body : null);
    } else {
      await chargingStationApi.AddChargingTableEnableDisableApi({
        id,
        status: 1,
      });
      this.props.getChargingStationsAction(selectedVendor ? body : null);
    }
    this.handleChargingTableEnableDisableModelClose();
  };

  handleGoBack = () => {
    if (this.props.history?.location?.selectedCity) {
      this.props.history.push("/vendor", {
        vendorId: this.props.history?.location?.selectedCity,
      });
    } else {
      this.props.history.goBack();
    }
  };

  render() {
    const vendorSelect = this.props?.VendorSelectWiseList?.result?.vendors;

    const count = this.props.ChargingStationCountList?.result;

    const TitleBoxData = [
      { title: "Total Charging Stations", number: count?.total_station },
      { title: "Approve Charging Stations", number: count?.approved_station },
      { title: "Pending Requests", number: count?.pending_request },
    ];

    return (
      <>
        <Stack sx={{ marginTop: "1.6rem" }}>
          <Paper sx={{ p: 3, mt: 1 }}>
            <Grid
              container
              item
              sx={12}
              direction={{ sm: "column", xs: "column", md: "row" }}
              style={{
                background: "#EFF5FF",
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "2rem",
                marginTop: "10px",
              }}
            >
              <Grid item xs={4}>
                <Text
                  sx={{
                    fontSize: "22px",
                    fontfamily: "Nunito Sans",
                    fontWeight: "400",
                    textTransform: "none",
                    color: "#707070",
                    opacity: 1,
                    marginTop: "20px",
                    marginLeft: "10px",
                  }}
                >
                  CHARGING STATIONS
                </Text>
              </Grid>
              <Grid p={2}>
                <Button sx={{ marginRight: "20px", background: "#DAE8FF" }}>
                  <Link
                    style={{
                      textDecoration: "none",
                    }}
                    to="charging/request"
                  >
                    <Text
                      sx={{
                        width: "120px",
                        height: "25px",
                        fontStyle: "normal",
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "22px",
                        color: "#2B70C5",
                      }}
                    >
                      See all requests
                    </Text>
                  </Link>
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Stack spacing={1}>
                <Stack
                  sx={{ marginBottom: "2rem", justifyContent: "space-between" }}
                  spacing={2}
                  direction={{ sm: "column", xs: "column", md: "row" }}
                >
                  {TitleBoxData?.map((prop, index) => (
                    <Box key={index} sx={{ display: "flex" }}>
                      <TitleBox data={prop} />
                    </Box>
                  ))}
                </Stack>
              </Stack>
            </Grid>

            <ChargingStationTable
              vendorIdDefault={this.props.history?.location?.VendorDetailId}
              selectedCity={this.props.history?.location?.selectedCity}
              handleOnchangeSelectCity={(val) =>
                this.handleOnchangeSelectCity(val)
              }
              vendorSelect={vendorSelect}
              handleGoBack={this.handleGoBack}
              data={this.props.chargingStationData}
              chargingPoint={this.props.getChargingPointData}
              handleChangeChPointAdd={this.handleChangeChPointAdd}
              handleChangeConnector={this.handleChangeConnector}
              handleAddConnector={this.addFieldsConnector}
              onDeleteClick={this.handleDeleteConfirmStationClick}
              handleSubmitAddChPoint={this.handleSubmitAddChPoint}
              handleAddChPoint={this.handleAddChPoint}
              handleAddChPointClose={this.handleAddChPointClose}
              handleShowChPoint={this.handleShowChPoint}
              handleShowChPointClose={this.handleShowChPointClose}
              handleOpenAddConnectorDr={this.handleOpenAddConnectorDr}
              handleCloseAddConnectorDr={this.handleCloseAddConnectorDr}
              viewDrawer={this.state.viewDrawer}
              addDrawer={this.state.addDrawer}
              handleDeleteConnector={this.handleDeleteConfirmConnectorClick}
              chargerTypes={this.props.chargerTypes}
              inputFields={this.state.formData.connectors}
              removeFieldsConnector={this.removeFieldsConnector}
              // ch connector
              addConnectorDrawer={this.state.addConnectorDrawer}
              EditConnectorDrawer={this.state.EditConnectorDrawer}
              handleCloseEditConnector={this.handleCloseEditConnector}
              handleOnclickEditConnectorOpen={
                this.handleOnclickEditConnectorOpen
              }
              handleSubmitConnector={this.handleSubmitConnector}
              hendleChangeConnectorAdd={this.hendleChangeConnectorAdd}
              handleSubmitEditConnector={this.handleSubmitEditConnector}
              handleChangeConnectorEdit={this.handleChangeConnectorEdit}
              EditCh_PointIndex={this.state.EditCh_PointIndex}
              EditCh_ConnectorIndex={this.state.EditCh_ConnectorIndex}
              handleChangeChPointEdit={this.handleChangeChPointEdit}
              chargingConnectorEdit={this.state.chargingConnectorEdit}
              handleSubmitEditChPoint={this.handleSubmitEditChPoint}
              EditChargingPointDrawer={this.state.EditChargingPointDrawer}
              handleCloseEditChPoint={this.handleCloseEditChPoint}
              handleOpenEditChPoint={this.handleOpenEditChPoint}
              isLoading={this.props.isLoading}
              handleChargingTableEnableDisableModelOpen={
                this.handleChargingTableEnableDisableModelOpen
              }
            />

            <Snackbar
              open={this.state.deleteSuccess}
              autoHideDuration={3000}
              onClose={() => this.setState({ deleteSuccess: false })}
              message="Charging Connector Deleted Successfully"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert severity="error">
                Charging Station Deleted Successfully
              </Alert>
            </Snackbar>
            <Snackbar
              open={this.state.charging_point_Success}
              autoHideDuration={3000}
              onClose={() => this.setState({ charging_point_Success: false })}
              message="Charging Station Deleted Successfully"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert severity="success">
                Charging Point Added Successfully
              </Alert>
            </Snackbar>
            {/* edit ch point success */}
            <Snackbar
              open={this.state.charging_point_Edit_Success}
              autoHideDuration={3000}
              onClose={() =>
                this.setState({ charging_point_Edit_Success: false })
              }
              message="Charging Station Deleted Successfully"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert severity="success">
                Charging Point updated Successfully
              </Alert>
            </Snackbar>

            <Snackbar
              open={this.state.charging_Connector_Success}
              autoHideDuration={3000}
              onClose={() =>
                this.setState({ charging_Connector_Success: false })
              }
              message="Charging Station Deleted Successfully"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert severity="success">
                Charging Connector Added Successfully
              </Alert>
            </Snackbar>

            {/* edit ch connector success */}
            <Snackbar
              open={this.state.charging_Connector_Edit_Success}
              autoHideDuration={3000}
              onClose={() =>
                this.setState({ charging_Connector_Edit_Success: false })
              }
              message="Charging Station Deleted Successfully"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert severity="success">
                Charging Connector updated Successfully
              </Alert>
            </Snackbar>

            <ConfirmDeleteStationModel
              open={this.state.deleteConfirmStationDaialog}
              handleClose={this.handleCloseDeleteStationConfirm}
              handleDelete={this.handleDeleteStationClick}
            />

            <ConfirmDeleteConnectorModel
              open={this.state.deleteConfirmConnectorDaialog}
              handleClose={this.handleCloseDeleteConnectorConfirm}
              handleDelete={this.handleDeleteConnectorClick}
            />

            <ChargingTableEnableDisable
              open={this.state.openEnableDisableChargingTable}
              handleclose={this.handleChargingTableEnableDisableModelClose}
              handleEnable={this.handleEnableClickChargingTable}
              ChargingTableStatus={this.state.ChargingTableStatus}
            />
          </Paper>
        </Stack>
      </>
    );
  }
}

export default ChargingStationTableContainer;
